import { Typography } from "@mui/material";
import React from "react";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";

const FullName = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => (
  <React.Fragment>
    <Typography
      sx={{
        fontWeight: "bold",
      }}
      variant="caption"
      component="p"
    >
      Teilnehmer:in
    </Typography>
    <Typography variant="body1" component="p">
      {appointment.participantFullName}
    </Typography>
  </React.Fragment>
);

export default FullName;
